import { ValueOf } from 'types';

export const Level = {
  DOCUMENT: 'document',
  MODULE: 'module',
} as const;
export type Level = ValueOf<typeof Level>;
